import styled from 'styled-components';
import { asRem } from 'utils';
import { colors } from 'components/Theme';

export default styled.div`
  .StripeElement {
    margin-bottom: -${asRem(16)};
  }

  a.link {
    color: ${colors.grey.c800};
    font-size: ${asRem(14)};
  }

  .submit-button {
    margin-top: ${asRem(24)};
    width: 100%;
  }
`;
